import React from 'react';

import { useStyletron } from 'baseui';
import { Unstable_StatefulDataTable } from 'baseui/data-table';
import debug from 'utils/debug';

const { METHOD } = debug('c:ModalWindows:DataTableViewer');

export default function(props) {
  METHOD('Table', { props });

  const [css] = useStyletron();

  const { columns, rows } = props;

  METHOD('Content', { columns, rows });

  return (
    <div className={css({ height: 'calc(90vh - 210px)', width: 'auto' })}>
      {columns.length && (
        // eslint-disable-next-line
        <Unstable_StatefulDataTable
          columns={columns}
          rows={rows}
          emptyMessage='Nothing to show'
        />
      )}
    </div>
  );
}
